import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { store } from "./store/store";

import { Provider, useDispatch } from "react-redux";
import { setLanguage } from "./store/app/general";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./scss/main.scss";

import "slick-carousel/slick/slick-theme.css";

import App from "./App";
// import reportWebVitals from "./reportWebVitals";

import apiService, { APIResponse } from "./hooks/api/axios";
import ormcoreService from "./hooks/api/ormcore";
import ormStationsService from "./hooks/api/stations";
import ormVehiclesService from "./hooks/api/vehicles";
// import userSession from "./hooks/app/userSession";
// const dispatch = useDispatch();

async function initializeAPI() {
  try {
    const appCode = process.env.REACT_APP_AUTHCODE as string;
    if (process.env.NODE_ENV === "development") {
      await apiService.fetchApiUrl(appCode);
    } else {
      await apiService.fetchApiUrlCDN();
    }
  } catch (error) {
    console.error("API Initialisierung fehlgeschlagen:", error);
  }
}

function LanguageInitializer() {
  const myEle = document.getElementById("crentReservation");
  if (myEle !== null && myEle.dataset.lang) {
    store.dispatch(setLanguage(myEle.dataset.lang));
  }
}

// Find all widget divs
const widgetDivs = document.querySelectorAll(".orm-widget");

function loadWidgets() {
  // Inject our React App into each class
  widgetDivs.forEach((div) => {
    const element = div as HTMLElement;
    const root = ReactDOM.createRoot(div as HTMLElement);
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App symbol={element.dataset.symbol} dataset={element.dataset} />
        </Provider>
      </React.StrictMode>,
    );
  });
}

async function initORM() {
  // userSession.initUserSession();
  // userSession.getUserSession("setSelectedStation");
  await initializeAPI();
  LanguageInitializer();
  await ormcoreService.fetchModules();
  await ormcoreService.fetchParameters();
  await ormcoreService.fetchTranslations();
  ormStationsService.fetchStations();
  ormVehiclesService.fetchVehicles();
  // console.log("ORM LOADED");
  loadWidgets();
}

initORM();
